//@ts-nocheck
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import styled from "styled-components";

import NationalMap from './NationalMap';
import StateMap from './StateMap';

import { loadSharedReportLink, getDetailedDistrictReportConfig } from './../../../actions/DetailedDistrictReportActions';
import MethodologyPdf from "./../../../downloads/CDDR-methodology.pdf";

// import event tracking log
import { withUserActionTracker } from "./../../../sharedUtilities/UserActionTracker";

import GovtReportHeader from '../GovtReportHeader';
import DashboardReportActionsBar from '../../../layouts/DashboardReportActionsBar';
import LoadingSpinner from '../../Common/LoadingSpinner';
import {isAgg, getReportUniversityName} from "../../../components/Common/Helpers";
import ViewReportModal from '../ViewReportModal';
import * as Helpers from '../../../components/Common/Helpers';
import { downloadFromUrlWithFallback } from "../../../sharedUtilities/downloadFromUrl";

// Detailed District Report Page
const DetailedDistrictReport = ({ match }) => {

    const reportDisplayId = useSelector(state => state.userProperties.report_display_id);
    const reportVintage = useSelector(state => state.userProperties.report_vintage_one_district);
    const userProperties = useSelector(state => state.userProperties);
    const universityName = getReportUniversityName(userProperties);
    const reportConfig = useSelector(state => state.detailedDistrictReportProperties.reportConfig);
    
    const dispatch = useDispatch();

    useEffect(() => {

        if (match.params !== undefined &&
            match.params["link_id"] != undefined &&
            match.params["p1"] != undefined &&
            match.params["p2"] != undefined) {

            dispatch(loadSharedReportLink(match.params["link_id"], match.params["p1"], match.params["p2"]));

        }
        else {
            // get report configuration
            dispatch(getDetailedDistrictReportConfig(reportDisplayId, reportVintage));
        }
    }, [reportDisplayId, reportVintage])

    if (!reportDisplayId || !reportVintage || !reportConfig) return <LoadingSpinner loadingText="Loading Report Data..." />
    const sharedLinkPageOnLoad = match.params !== undefined && match.params["link_id"] !== undefined && match.params["p1"] !== undefined && match.params["p2"] !== undefined;
    const downloadMethodology = async (e) => {
        e.preventDefault();
        await downloadFromUrlWithFallback(MethodologyPdf);
    };

    return (
        <Container className="cddr-report">
            {sharedLinkPageOnLoad && (!match.params["ne"]) ? <ViewReportModal filetype={"Congressional Detail District"} /> : null}
            <DashboardReportActionsBar currentUrl={match.url} noMargin />
            <div className="row report-row cddr-header-row">
                <GovtReportHeader
                    report_university_name={universityName}
                    heading_text={`The Impact of Research-Related Spending by Congressional District, FY ${reportConfig && reportConfig.min_year} - ${reportConfig.max_year && reportConfig.max_year}`}
                />
            </div>
            <div className="row report-row">
                <p className="report-text">This report shows the impact of federally funded research-related spending and higher-education activity in each U.S. Congressional District. See the <a href={MethodologyPdf} onClick={downloadMethodology}>methodology document</a> for details. {isAgg(reportDisplayId) ? Helpers.CDDR_titleTextForAgg(universityName, reportConfig.description, reportConfig.min_year, reportConfig.max_year) : ""}</p>
            </div>
            <Route exact path={`${match.path}`} component={NationalMap} />
            <div className="row report-row">
                <Route path={`${match.path}/:stateCode`} component={StateMap} />
            </div>
        </Container>
    );
}

const Container = styled.div`
    max-width: min(1080px, 100%);
`;

export default withUserActionTracker(
    DetailedDistrictReport,
    "Congressional District Detail Report",
    "visited landing page"
);